<template>
  <button class="rb-button-outline"
    :class="{
      'rb-button-outline--icon-only': iconOnly,
      'rb-button-outline--no-border': noBorder,
      'rb-button-outline--touch': isTouchCentric,
    }"
    :disabled="disabled"
    @touchstart.prevent.capture.stop="handleButtonClick"
    @click.prevent.capture.stop="handleButtonClick"
  >
    <div class="rb-button-outline__background"></div>
    <div class="rb-button-outline__content">
      <p class="rb-button-outline__copy" v-if="!iconOnly">
        <slot></slot>
      </p>
      <span class="rb-button-outline__icon">
        <icon class="rb-button-outline__icon--icon">
          {{buttonIcon}}
        </icon>
      </span>
    </div>
  </button>
</template>

<script>
// outline button component
import button from './../mixins/button';

export default {
  name: 'rb-button-outline',
  mixins: [button],
};
</script>

<style lang="scss">
.rb-button-outline {
  @include button-base;
  border-width: $size-border-width-button-outline;
  &__background {
    background-color: $color-base-white-base;
    width: 0;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    transition: width 300ms ease;
  }
  &__copy {
    color: $color-base-white-base;
  }
  &__icon {
    display: flex;
    &--icon {
      align-self: center;
      color: $color-base-white-base;
      margin-top: -0.2rem;
      margin-left: -0.2rem;
    }
  }
  &:hover {
    &:not(.rb-button-outline--no-border):not(:disabled):not(.rb-button-outline--touch) {
      .rb-button-outline {
        &__background {
          width: 100%;
          left: 0;
        }
        &__copy {
          color: $color-base-ninja-dark-blue-base;
        }
        &__icon {
          &--icon {
            color: $color-base-ninja-dark-blue-base;
          }
        }
      }
    }
  }
  &:disabled {
    opacity: $number-opacity-button-disabled;
  }
  &--icon-only {
    padding: 0;
    height: 5rem;
    width: 5rem;
    justify-content: center;
    align-items: center;
  }
  &--no-border {
    border: none;
  }
}
</style>
